import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="w-full px-4 md:px-8 py-20 md:py-28 flex flex-col items-center text-center">
      <span className="w-16 h-16 rounded-full bg-primary-50 text-primary-500 flex items-center justify-center mb-5">
        <i className="ri-emotion-sad-line text-3xl"></i>
      </span>
      <p className="text-6xl md:text-8xl font-black font-heading text-background-200 select-none">
        404
      </p>
      <h1 className="text-xl md:text-2xl font-bold font-heading text-foreground-900 mt-2">
        页面走丢了
      </h1>
      <p className="text-sm text-foreground-500 mt-2 max-w-md">
        你访问的页面不存在或已被移除，不如回首页看看最新上线的精彩视频吧。
      </p>
      <p className="text-xs text-foreground-400 mt-1 break-all">{location.pathname}</p>
      <div className="flex items-center gap-3 mt-6 flex-wrap justify-center">
        <Link
          to="/"
          className="inline-flex items-center gap-1 px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-line"></i>
          返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex items-center gap-1 px-5 py-2.5 rounded-md border border-background-300 text-sm font-medium text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-search-line"></i>
          去搜索
        </Link>
      </div>
    </div>
  );
}